import React from 'react';
import { Dropdown } from 'antd';
import getPopupContainer from '../../Hooks/getPopupContainer';
import { DropdownButtonProps as DropdownButtonCopyProps } from 'antd/lib/dropdown';

export type DropdownButtonProps = DropdownButtonCopyProps;

const ProDropdownButton: React.FC<DropdownButtonProps> = props => {
  const { children, ...resProps } = props;
  return (
    <Dropdown.Button getPopupContainer={getPopupContainer} {...resProps}>
      {children}
    </Dropdown.Button>
  );
};

export default ProDropdownButton;
